<template>
  <a :class="{ 'w--current': selected }" class="tab w-inline-block w-tab-link">
    {{ text }}
  </a>
</template>

<script>
  export default {
    name: 'PublicTenderTabButton',
    props: {
      text: {
        type: String,
        required: true,
      },
      selected: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style scoped lang="scss">
  @import 'src/styles/pages/public-tender';
</style>
